import axios from 'axios';

import { Auth } from './Auth';

export const axiosClient = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

if (localStorage.getItem('jwt')) {
  axiosClient.defaults.headers['Authorization'] = `Bearer ${localStorage.getItem('jwt')}`;
}

axiosClient.interceptors.response.use(
  function (value) {
    return value;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      Auth.signOut();

      const config = error.config;
      delete config.headers['Authorization'];

      return new Promise((resolve, reject) => {
        axios
          .request(config)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    } else {
      return Promise.reject(error);
    }
  }
);
